module.exports = new __parcel__URL__("67619_sq.ca088609.jpg").toString();